import { getFeatureConfig } from '@luna/feature-config';

const THOUSAND_DECIMAL = 3;

// We want to replace thousandSeparator (.)
// for decimalSeparator (,)
// if user used it as decimalSeparator
// (at the end of the value and separating less than 3 places)
export function replaceThousandSeparatorToDecimal(_val: string) {
    let val = _val;

    if (
        val.indexOf(getFeatureConfig((config) => config.base.decimalSeparator)) === -1 &&
        val.indexOf(getFeatureConfig((config) => config.base.thousandSeparator)) > -1
    ) {
        const thousandSplit = val.split(
            getFeatureConfig((config) => config.base.thousandSeparator),
        );
        if (thousandSplit.length > 1) {
            const lastOne = thousandSplit.pop() || '';
            if (lastOne.length < THOUSAND_DECIMAL) {
                val =
                    thousandSplit.join(
                        getFeatureConfig((config) => config.base.thousandSeparator),
                    ) +
                    getFeatureConfig((config) => config.base.decimalSeparator) +
                    lastOne;
            }
        }
    }
    return val;
}

export function replacePeriodForDecimalSeparator(value: string) {
    // we treat period as an optional decimal separator
    // when there is no other decimal separator
    // unless it is set as a thousand separator
    if (
        getFeatureConfig((config) => config.base.thousandSeparator) !== '.' &&
        value.indexOf('.') > -1 &&
        value.indexOf(getFeatureConfig((config) => config.base.decimalSeparator)) === -1
    ) {
        return value.split('.').join(getFeatureConfig((config) => config.base.decimalSeparator));
    }
    return value;
}
